import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useState, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import { AdvertiserMarginSchema } from '../../../../../../../schemas/ProjectManager/MarginSchema'
import axiosService from '../../../../../../../utils/AxiosService'
import Input from '../../../../../../FormComponents/Input'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import { useReadOnly } from '../../../../../../../contexts/ReadOnlyContext'

export default observer(function AdvertiserMarginField({ action }) {
  const readOnly = useReadOnly()
  const { id } = useParams()
  const { primaryScenarioId } = useContext(CampaignContext)
  const [currentTimeout, setCurrentTimeout] = useState(null)

  const changeMargin = advertiser_margin => {
    if (currentTimeout) clearTimeout(currentTimeout)
    setCurrentTimeout(setTimeout(() => submitAdvertiserMargin(advertiser_margin), 1000))
  }

  const handleFormSubmit = values => {
    if (currentTimeout) clearTimeout(currentTimeout)
    const value = typeof values?.advertiser_margin === 'object'
      ? values.advertiser_margin?.advertiser_margin
      : values?.advertiser_margin
    submitAdvertiserMargin(value)
  }

  const submitAdvertiserMargin = advertiser_margin => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/actions/${action.id}`, { campaign_scenario_action: { advertiser_margin }})
    .then((updatedAction) => {
      toastSuccess('Margin updated')
      action.advertiser_margin = updatedAction.advertiser_margin
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  return (
    <Formik
      key={action.advertiser_margin}
      initialValues={{ advertiser_margin: action.advertiser_margin }}
      validationSchema={AdvertiserMarginSchema}
      onSubmit={handleFormSubmit}
    >
      {({ errors, touched, handleBlur, handleChange, values }) => (
        <Form className="w-full">
          <div className="relative">
            <Input
              disabled={readOnly}
              addon="%"
              addonPosition="end"
              error={touched.advertiser_margin && errors.advertiser_margin}
              name="advertiser_margin"
              noLabelPadding
              onChange={(e) => {
                changeMargin(e.target.value)
                handleChange(e)
              }}
              onBlur={handleBlur}
              value={values.advertiser_margin}
              overrideClassName="h-7"
              topMargin="mt-0"
            />
          </div>
        </Form>
      )}
    </Formik>
  )
})